import { render } from "./editor-text-simple.vue?vue&type=template&id=4bbf74ea"
import script from "./editor-text-simple.vue?vue&type=script&lang=js"
export * from "./editor-text-simple.vue?vue&type=script&lang=js"

import "./editor-text-simple.vue?vue&type=style&index=0&id=4bbf74ea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__